module.exports = __webpack_public_path__ + "img/green-map-marker.a778d8d1.svg";